
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import keyCodeMapperCharacter from '@/utils/keycodemap.utils'
import * as onScan from 'onscan.js'
import ProductProvider from '@/resources/product.provider'
import StockLocationProvider from '@/resources/stock-location.provider'

@Component({
  components: {},
  computed: {
    ...mapState({
      selectBranch: (state: any) => state.Store.selectBranch
    })
  }
})
export default class MappingLocation extends Vue {
  productService = new ProductProvider()

  stockLocationService = new StockLocationProvider()

  location: any = null

  products: any = []

  selectBranch!: any

  loadingLocation = false

  loadingProduct = false

  loadingMapping = false

  mounted (): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this
    onScan.attachTo(document, {
      suffixKeyCodes: [13],
      reactToPaste: true,
      onScan (sCode) {
        const patternUrl = /^(https:\/\/www\.gentlewomanonline\.com\/|https:\/\/gentlewomanonline\.com\/|https:\/\/www\.matter-makers\.com\/|https:\/\/matter-makers\.com\/)/
        const patternLocation = /^location::/
        if (patternUrl.test(sCode.toLowerCase())) {
          const splitCodeFromUrl = sCode.split('/')
          const code = splitCodeFromUrl[splitCodeFromUrl.length - 1]
          if (code) _this.addToMappingList(code)
        } else if (patternLocation.test(sCode)) {
          _this.getLocation(sCode.split('::')[1])
        } else {
          _this.$buefy.toast.open({ message: 'QR Code นี้ไม่สามารถใช้งานได้', type: 'is-danger' })
        }
      },
      keyCodeMapper (oEvent: any) {
        if (keyCodeMapperCharacter[+oEvent.keyCode] !== undefined) {
          return keyCodeMapperCharacter[+oEvent.keyCode][+oEvent.shiftKey]
        }
        return onScan.decodeKeyEvent(oEvent)
      }
    })
  }

  async getLocation (locationId: string): Promise<void> {
    try {
      this.loadingLocation = true
      const { data } = await this.stockLocationService.getLocationById(locationId, {
        warehouse: this.selectBranch.warehouse.id
      })
      if (data) {
        this.location = data
      } else {
        this.$buefy.toast.open({ message: 'Location นี้ไม่อยู่ใน Warehouse ที่คุณเลือก', type: 'is-danger' })
      }
    } catch (error) {
      this.$buefy.toast.open({ message: 'เกิดข้อผิดพลาดในการดึงข้อมูล location', type: 'is-danger' })
    } finally {
      this.loadingLocation = false
    }
  }

  async addToMappingList (code: string): Promise<void> {
    const isExistingIndex = this.products.findIndex((p: any) => p.code === code)
    if (isExistingIndex === -1) {
      this.getProductInfo(code)
    } else {
      this.products[isExistingIndex].qty += 1
      this.products[isExistingIndex].timeStamp = Date.now()
      this.products.sort((a: any, b: any) => b.timeStamp - a.timeStamp)
    }
  }

  saveMapping (): void {
    this.$buefy.dialog.alert({
      title: 'บันทึก Mapping Location',
      message: 'ต้องการบันทึกการ Mapping Location หรือไม่',
      confirmText: 'บันทึก',
      cancelText: 'ยกเลิก',
      canCancel: true,
      onConfirm: () => {
        this.mappingLocation()
      },
      type: 'is-info',
      hasIcon: true
    })
  }

  async mappingLocation (): Promise<void> {
    // call api save
    try {
      this.loadingMapping = true
      await this.stockLocationService.mappingLocation(
        {
          warehouse: this.selectBranch.warehouse,
          location: this.location.id,
          productSkus: this.products.map((p: any) => ({ qty: p.qty, code: p.code }))
        }
      )
      this.$buefy.toast.open({ message: 'การบันทึกสำเร็จ', type: 'is-success' })
      this.location = null
      this.products = []
    } catch (error) {
      this.$buefy.toast.open({ message: 'การบันทึกผิดพลาด', type: 'is-danger' })
    } finally {
      this.loadingMapping = false
    }
  }

  // eslint-disable-next-line class-methods-use-this
  defaultEmptyObject (obj: any, key: string, defaultValue: string): string {
    return obj && obj[key] ? obj[key] : defaultValue
  }

  incrementItem (code: string): void {
    const idx = this.products.findIndex((p: any) => p.code === code)
    if (idx !== -1) this.products[idx].qty += 1
  }

  decrementItem (code: string): void {
    const idx = this.products.findIndex((p: any) => p.code === code)
    if (idx !== -1) {
      if (this.products[idx].qty === 1) this.products.splice(idx, 1)
      else this.products[idx].qty -= 1
    }
  }

  removeItem (code: string): void {
    const idx = this.products.findIndex((p: any) => p.code === code)
    if (idx !== -1) this.products.splice(idx, 1)
  }

  async getProductInfo (code: string): Promise<void> {
    // get from api
    try {
      this.loadingProduct = true
      const { data: productSku } = await this.productService.getProductByCode({
        skuCodes: [code]
      })
      const productInfo = productSku?.length ? productSku[0] : null
      if (productInfo) {
        this.products.push({ ...productInfo, qty: 1, timeStamp: Date.now() })
        this.products.sort((a: any, b: any) => b.timeStamp - a.timeStamp)
      } else {
        this.$buefy.toast.open({ message: 'QR Code นี้ไม่สามารถใช้งานได้', type: 'is-danger' })
      }
    } catch (error) {
      this.$buefy.toast.open({ message: 'เกิดข้อผิดพลาดในการดึงข้อมูลสินค้า', type: 'is-danger' })
    } finally {
      this.loadingProduct = false
    }
  }

  // eslint-disable-next-line class-methods-use-this
  beforeDestroy (): void {
    onScan.detachFrom(document)
  }
}
